import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-oee-state-remarks',
  templateUrl: './oee-state-remarks.component.html',
  styleUrls: ['./oee-state-remarks.component.css']
})
export class OeeStateRemarksComponent implements OnInit {
    public oeeStateKeyno;

    public itemsListRemarks: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.oeeStateKeyno = this.stateService.getStateParams()['oeestate_keyno'];
    }

    private async loadRemarks() {
        if (!!this.oeeStateKeyno) {
            this.itemsListRemarks = await this.datatask.Post(246, { oeestate_keyno: this.oeeStateKeyno });
        }
    }

    private async init() {
        this.loadRemarks();
    }

    ngOnInit() {
        this.init();
    }
}
